import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  RouterStateSnapshot,
  UrlSegment,
  UrlSerializer,
  UrlTree,
} from '@angular/router';
import { ArkikStatusService } from '@core/services/common/arkik-status.service';

@Injectable({
  providedIn: 'root',
})
export class OfflineGuard implements CanActivate, CanLoad, CanActivateChild {
  private readonly logoutUrl = '/logout-offline';

  private get haveToken(): boolean {
    return this._arkikStatusService.getOfflineToken() !== '';
  }

  private validateTokenOffline(): boolean | UrlTree {
    if (this.haveToken) return true;

    return this._urlSerializer.parse(this.logoutUrl);
  }

  constructor(
    private readonly _urlSerializer: UrlSerializer,
    private readonly _arkikStatusService: ArkikStatusService,
  ) {}

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.validateTokenOffline();
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.validateTokenOffline();
  }

  canLoad(route: Route, segments: UrlSegment[]): boolean | UrlTree {
    return this.validateTokenOffline();
  }
}
